import { MAX_CHARACTERS_TO_SEARCH } from './constants';

export const truncateSearchText = (text: string) =>
  text.length > MAX_CHARACTERS_TO_SEARCH
    ? text.substring(0, MAX_CHARACTERS_TO_SEARCH)
    : text;
